import React, {useContext} from "react" ;
import {Route, Switch, useLocation} from "react-router-dom";

import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";

import { getAdminRouterLink, getAdminRouterPath} from "root/Wieldy/routePaths";

import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import AppSidebarHeader from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarHeader";
import AdminOrganisationSubmenu from "./AdminOrganisationSubmenu";
import {getDefaultMenuForPath} from "root/Wieldy/ApplicationModules/Common/navHelpers";
import AdminDomainSubmenu from "root/Wieldy/ApplicationModules/Admin/Sidebar/AdminDomainSubmenu";

const AdminAppSidebar= (props) =>
{
    const { pathname }  = useLocation();

    const menuRoutes = [
        { match: 'domains' , defaultMenu: 'domains', default: true},
        { match: 'dashboard' , defaultMenu: 'dashboard'},
        { match: 'organisations' , defaultMenu: 'organisations'},
    ]

    const getDefaultMenu = () =>{
        return getDefaultMenuForPath( pathname, menuRoutes ) ;
    }

    return (
        <div key='sb' className="dt-module__sidebar">

            <AppSidebarHeader iconName={props.iconName} title={props.title} />

            <div key='aa' className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">

                    <AppSidebarGroup key='asbg' title='View' default={getDefaultMenu()}>
                        <AppSidebarMenuItem link={getAdminRouterLink('domains')} title='Domains' iconName='icon-family' name='domains'/>
                        <AppSidebarMenuItem link={getAdminRouterLink('organisations')} title='Organisations' iconName='icon-family' name='organisations'/>
                        <AppSidebarMenuItem link={getAdminRouterLink('dashboard')} title='Dashboard' iconName='icon-dashboard' name='dashboard'/>
                    </AppSidebarGroup>

                    <Switch>
                        <Route path={getAdminRouterPath('organisations')} render={(thisprops) => <AdminOrganisationSubmenu {...thisprops}/>}/>
                        <Route path={getAdminRouterPath('domains')} render={(thisprops) => <AdminDomainSubmenu {...thisprops}/>}/>
                    </Switch>

                </ul>

                <ScrollRails />

            </div>

        </div>
    ) ;
}

export default AdminAppSidebar;
